import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import {
  Auth,
  GoogleAuthProvider,
  signInWithPopup,
  TwitterAuthProvider,
} from '@angular/fire/auth';
import { MatDialogRef } from '@angular/material/dialog';
import { MatListModule } from '@angular/material/list';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faGoogle, faTwitter } from '@fortawesome/free-brands-svg-icons';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [MatListModule, FontAwesomeModule, TranslateModule],
})
export class LoginComponent {
  faTwitter = faTwitter;
  faGoogle = faGoogle;

  private afAuth = inject(Auth);

  constructor(private refDialog: MatDialogRef<LoginComponent>) {}

  async login(type: 'twitter' | 'google') {
    if (type === 'twitter') {
      await signInWithPopup(this.afAuth, new TwitterAuthProvider());
    } else if (type === 'google') {
      await signInWithPopup(this.afAuth, new GoogleAuthProvider());
    } else {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const _: never = type; // type が 'twitter' でも 'google' でもない場合にコンパイルエラーを出す
    }
    this.refDialog.close();
  }
}
